import { EmailTemplate } from "./models";
import { EmailTemplateSchema } from "./schema";
import { CreateEmailTemplatePayload, UpdateEmailTemplatePayload } from "./models/payloads";

export function emailTemplatePrimaryTrigger(template: EmailTemplate) {
  return template?.deliverAtTrigger;
}

/**
 * Transform API response data to form data
 * No conversion needed for triggers - they use the same format now
 *
 * @param data - EmailTemplate from API response
 * @returns EmailTemplateSchema ready for form initialization
 */
export function toEmailTemplateFormData(data: EmailTemplate): EmailTemplateSchema {
  const {
    deliverAtTrigger = undefined,
    paths = [],
    ...rest
  } = data;

  return {
    ...rest,
    deliverAtTrigger,
    paths,
    allowWeekends: false,
  } as EmailTemplateSchema;
}

/**
 * Transform form data to API create payload
 * Removes form-only fields and ensures correct structure for API
 */
export function toCreateEmailTemplatePayload(formData: EmailTemplateSchema): CreateEmailTemplatePayload {

  const { paths, ...rest } = formData;

  // Type assertion needed because form types differ from API types
  return rest as CreateEmailTemplatePayload;
}

/**
 * Transform form data to API update payload
 * Same as create but all fields optional
 */
export function toUpdateEmailTemplatePayload(formData: Partial<EmailTemplateSchema>): UpdateEmailTemplatePayload {

  const { paths, ...rest } = formData;

  return rest as UpdateEmailTemplatePayload;
}
